export default {
  order: ['order_management']
}
